import { Component } from 'react';
import CommerceFilterIntent from '../../../../../components/CommerceFilterIntent';

class ExtraBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="table-additional-view">
                    <div className="table-additional-view-btns">
                        <CommerceFilterIntent
                            select={this.props.select}
                            handleSelectChange={this.props.handleSelectChange}
                        />
                    </div>
                    <div className="toggle-Invalid-items">
                        <a
                            style={
                                !this.props.selectedDomains?.length
                                    ? { pointerEvents: 'none', opacity: 0.5 }
                                    : {}
                            }
                            href={`/commerce/${this.props.project_id}/?keyword=${
                                this.props.keyword
                            }&own_domain=${
                                this.props.own_domain
                            }&view=content_gaps&comp_domains=${this.props.selectedDomains?.join(
                                ',',
                            )}`}
                            className="button button-filled button-primary width-sm btn d-flex align-items-center justify-content-center mr-10"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t('commerce.detail.market_share.compare')}
                        </a>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraBox;
